<template>
  <div id="protocol" >
  	<div class="bgdiv" v-html="info"></div>
  </div>

</template>

<script>
// import protocoldesc from '@/assets/js/guloudesc.js';
import protocoldesc from '@/assets/js/gulou2024.js';
export default{
	name:'protocol',
	data(){
		return {
			info:'',
			status:1
		}
	},
	created(){
    this.status = this.$route.query.status || 1;
	document.title = '鼓楼数字政协';
    if(this.status == 1){
    //   this.info = protocoldesc.iosprivacy;
		this.info = protocoldesc.privacy;

    }else if(this.status == 2){
		// this.info = protocoldesc.iosserve;
      	this.info = protocoldesc.serve;
    }
		// this.status = this.$route.query.status || 1;
	}
}



</script>
<style lang='scss'>
#protocol{
	font-size:15px;
	width:100%;
	height:100%;
	position:absolute;
	overflow-y:auto;
	-webkit-overflow-scrolling: touch;
	.bgdiv{
		padding:10px;
		width:100%;
		box-sizing: border-box !important;
		p{
			margin:20px 0;
			line-height:30px;
			font-size:18px;
			white-space: pre-wrap;
			word-break:break-all;
		}
	}
}
</style>
